import { useIntl } from "react-intl";
import { xaiCallStatusColor } from "@lib/helpers/ColorHelper";
import { XAICallStatus } from "@lib/types/xAI";
import { AppTag } from "@lib/components/AppComponents";
import { darken } from "polished";

type Props = {
  status: XAICallStatus | string;
  size?: "small" | "default";
};

const XAICallStatusTag = (props: Props) => {
  const { status, size = "default" } = props;
  const { messages } = useIntl();

  const statusUpper =
    typeof status === "string" ? status.toUpperCase() : status;
  const statusSize = size === "small" ? 12 : 14;

  const color = xaiCallStatusColor(statusUpper);

  return (
    <AppTag
      color={color}
      style={{
        fontSize: statusSize,
        borderColor: darken(0.3, color),
        borderWidth: 2,
        borderStyle: "solid",
      }}
    >
      {messages["enums.xaiCallStatus"][statusUpper] || messages["common.na"]}
    </AppTag>
  );
};

export default XAICallStatusTag;
